// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1vpe6","footer":"Form_footer__JYiDf"};